import { noop } from 'lodash-es';
import * as actionTypes from '../constants/actionTypes';
import { getExternalPrototypeUrl } from '../selectors';
import { getOverlay } from '../selectors/overlay';
import { getCurrentScreen, getPendingAndLoadedScreenCounts, } from '../selectors/screen';
export default (function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.onScreenChange, onScreenChange = _c === void 0 ? noop : _c, _d = _b.onShowComments, onShowComments = _d === void 0 ? noop : _d, _e = _b.onHideComments, onHideComments = _e === void 0 ? noop : _e, _f = _b.onAddNewAnnotation, onAddNewAnnotation = _f === void 0 ? noop : _f, _g = _b.onMoveAnnotation, onMoveAnnotation = _g === void 0 ? noop : _g, _h = _b.onHighlightComment, onHighlightComment = _h === void 0 ? noop : _h, _j = _b.onUnHighlightComment, onUnHighlightComment = _j === void 0 ? noop : _j, _k = _b.onShowOverlay, onShowOverlay = _k === void 0 ? noop : _k, _l = _b.onHideOverlay, onHideOverlay = _l === void 0 ? noop : _l, _m = _b.onLeaveAnnotationMode, onLeaveAnnotationMode = _m === void 0 ? noop : _m, _o = _b.onPlayerReady, onPlayerReady = _o === void 0 ? noop : _o, _p = _b.onClick, onClick = _p === void 0 ? noop : _p, _q = _b.onMissedClick, onMissedClick = _q === void 0 ? noop : _q, _r = _b.onReplayEnded, onReplayEnded = _r === void 0 ? noop : _r, _s = _b.onReplayPaused, onReplayPaused = _s === void 0 ? noop : _s, _t = _b.onReplayProgress, onReplayProgress = _t === void 0 ? noop : _t, _u = _b.onReplayEvent, onReplayEvent = _u === void 0 ? noop : _u;
    var previousScreenID;
    var isPlayerReady = false;
    return function (action, state, previousState) {
        var isExternalPrototype = !!getExternalPrototypeUrl(state);
        if (isExternalPrototype) {
            return;
        }
        switch (action.type) {
            case actionTypes.CLICK:
                onClick(action.position);
                break;
            case actionTypes.MISSED_CLICK:
                onMissedClick(action.position);
                break;
            case actionTypes.SCREEN_TRANSITION_COMPLETED: {
                // This will encompass any action where the screen is set or changes
                if (areScreenTransitionsComplete(state)) {
                    var screen = getCurrentScreen(state);
                    var hoverStack = state.hoverStack;
                    if (screen.id !== previousScreenID && hoverStack.length === 0) {
                        onScreenChange(screen);
                        /*
                         * SCREEN_TRANSITION_COMPLETED gets dispatched multiple times per screen.
                         * Reset previous screen to prevent onScreenChange
                         * being called multiple times for one screen
                         */
                        previousScreenID = screen.id;
                    }
                }
                break;
            }
            case actionTypes.SHOW_OVERLAY: {
                // TODO probably want a single event for screen and overlay transitions
                var overlay = getOverlay(state, true).overlay;
                onShowOverlay(overlay);
                break;
            }
            case actionTypes.HIDE_OVERLAY: {
                var screen = getCurrentScreen(state);
                onHideOverlay(screen);
                break;
            }
            case actionTypes.SHOW_COMMENTS:
                onShowComments();
                break;
            case actionTypes.HIDE_COMMENTS:
                onHideComments();
                break;
            case actionTypes.HIGHLIGHT_COMMENT:
                onHighlightComment(action.id);
                break;
            case actionTypes.UNHIGHLIGHT_COMMENT:
                onUnHighlightComment();
                break;
            case actionTypes.ADD_NEW_ANNOTATION:
                {
                    var _a = previousState.annotation.nextAnnotation, commentUUID = _a.commentUUID, reference = _a.reference;
                    var newAnnotation = state.annotation.annotations[commentUUID];
                    onAddNewAnnotation(commentUUID, reference, newAnnotation);
                }
                break;
            case actionTypes.POSITION_ANNOTATION: {
                var commentUUID = action.commentUUID;
                var annotation = state.annotation.annotations[commentUUID];
                onMoveAnnotation(annotation);
                break;
            }
            case actionTypes.LOCATION_CHANGED: {
                var highlightedComment = action.highlightedComment;
                if (highlightedComment) {
                    onHighlightComment(highlightedComment);
                }
                break;
            }
            case actionTypes.LEAVE_ANNOTATION_MODE:
                onLeaveAnnotationMode();
                break;
            case actionTypes.IMAGE_LOADED:
                {
                    var noOfPendingImages = getPendingAndLoadedScreenCounts(state).noOfPendingImages;
                    if (noOfPendingImages === 0 && !isPlayerReady) {
                        onPlayerReady();
                        isPlayerReady = true;
                    }
                }
                break;
            // TODO move recording/replay into its own package with prototype-viewer as a dependency?
            case 'REPLAY_ENDED':
                onReplayEnded();
                break;
            case 'REPLAY_PAUSED':
                onReplayPaused();
                break;
            case actionTypes.REPLAY_PROGRESS:
                onReplayProgress(action.played);
                break;
            case actionTypes.REPLAY_ON_EVENT:
                onReplayEvent(action.event);
                break;
            default:
                break;
        }
    };
});
function areScreenTransitionsComplete(state) {
    var _a = state.screen, previousScreen = _a.previousScreen, isTransitionComplete = _a.isTransitionComplete;
    return (isInitialPageLoadAndCurrentScreenTransitioned(previousScreen, isTransitionComplete) || areBothScreensTransitioned(isTransitionComplete));
}
function isInitialPageLoadAndCurrentScreenTransitioned(previousScreen, isTransitionComplete) {
    return !previousScreen && isTransitionComplete.current;
}
function areBothScreensTransitioned(isTransitionComplete) {
    var previous = isTransitionComplete.previous, current = isTransitionComplete.current;
    return previous && current;
}
